import Base from './Base';

class Ai extends Base {
    prompt(agent, prompt = null, data = null, opts = null) {
        return this.postJSON(
            `/ai/${agent}`,
            {
                prompt,
                ...data,
            },
            opts,
        );
    }
}

export default Ai;
